import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_TITLE_DESIGN_SYSTEM } from '../helpers/_constants'

// Lazy load design system components for better code splitting
const DesignSystem = () => import('.')
const CADesignSystem = () => import('./pages')
const CABadges = () => import('./pages/CABadges')
const CAButtons = () => import('./pages/CAButtons')
const CAColors = () => import('./pages/CAColors')
const CAContainers = () => import('./pages/CAContainers')
const CADividers = () => import('./pages/CADividers')
const CAEmptyStates = () => import('./pages/CAEmptyStates')
const CAFormElements = () => import('./pages/CAFormElements')
const CAGroups = () => import('./pages/CAGroups')
const CAHeadings = () => import('./pages/CAHeadings')
const CAIcons = () => import('./pages/CAIcons')
const CAKeys = () => import('./pages/CAKeys')
const CANavigation = () => import('./pages/CANavigation')
const CANotifications = () => import('./pages/CANotifications')
const CAPopovers = () => import('./pages/CAPopovers')
const CAProgressBars = () => import('./pages/CAProgressBars')
const CATooltips = () => import('./pages/CATooltips')
const CATables = () => import('./pages/tables/CATables')

const designSystemRoute: RouteRecordRaw = {
	children: [
		{
			component: CADesignSystem,
			meta: {
				breadcrumb: 'Design System',
				icon: 'SVGHome',
				title: `Home ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'home',
			path: '',
		},
		{
			component: CABadges,
			meta: {
				breadcrumb: 'Badges',
				title: `Badges ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'badges',
			path: 'badges',
		},
		{
			component: CAButtons,
			meta: {
				breadcrumb: 'Buttons',
				title: `Buttons ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'buttons',
			path: 'buttons',
		},
		{
			component: CAColors,
			meta: {
				breadcrumb: 'Colors',
				title: `Colors ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'colors',
			path: 'colors',
		},
		{
			component: CAContainers,
			meta: {
				breadcrumb: 'Containers',
				title: `Containers ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'containers',
			path: 'containers',
		},
		{
			component: CADividers,
			meta: {
				breadcrumb: 'Dividers',
				title: `Dividers ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'dividers',
			path: 'dividers',
		},
		{
			component: CAEmptyStates,
			meta: {
				breadcrumb: 'Empty States',
				title: `Empty States ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'emptyStates',
			path: 'empty-states',
		},
		{
			component: CAFormElements,
			meta: {
				breadcrumb: 'Form Elements',
				title: `Form Elements ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'formElements',
			path: 'form-elements',
		},
		{
			component: CAGroups,
			meta: {
				breadcrumb: 'Groups',
				title: `Groups ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'groups',
			path: 'groups',
		},
		{
			component: CAHeadings,
			meta: {
				breadcrumb: 'Headings',
				title: `Headings ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'headings',
			path: 'headings',
		},
		{
			component: CAIcons,
			meta: {
				breadcrumb: 'Icons',
				title: `Icons ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'icons',
			path: 'icons',
		},
		{
			component: CAKeys,
			meta: {
				breadcrumb: 'Keys',
				title: `Keys ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'keys',
			path: 'keys',
		},
		{
			component: CANavigation,
			meta: {
				breadcrumb: 'Navigation',
				title: `Navigation ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'navigation',
			path: 'navigation',
		},
		{
			component: CANotifications,
			meta: {
				breadcrumb: 'Notifications',
				title: `Notifications ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'notifications',
			path: 'notifications',
		},
		{
			component: CAPopovers,
			meta: {
				breadcrumb: 'Popovers',
				title: `Popovers ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'popovers',
			path: 'popovers',
		},
		{
			component: CAProgressBars,
			meta: {
				breadcrumb: 'Progress Bars',
				title: `Progress Bars ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'progress-bars',
			path: 'progress-bars',
		},
		{
			component: CATables,
			meta: {
				breadcrumb: 'Tables',
				title: `Tables ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'tables',
			path: 'tables',
		},
		{
			component: CATooltips,
			meta: {
				breadcrumb: 'Tooltips',
				title: `Tooltips ${DEFAULT_TITLE_DESIGN_SYSTEM}`,
			},
			name: 'tooltips',
			path: 'tooltips',
		},
	],
	component: DesignSystem,
	path: '/design-system',
}

export default designSystemRoute
